import Image from 'next/image';
import { Text, useBreakpointValue } from '@chakra-ui/react';

export const ViewSectionClientGroups = (props) => {
  const {profile } = props;
  const { clientGroups } = profile;

  const iconHeight = useBreakpointValue({ base: 24, md: 48 });

  const renderIcon = (client) => {
    switch (client) {
      case 'Adolescents':
        return (
          <Image
            src="/static/icons/Adolescents.png"
            height={iconHeight}
            width={iconHeight}
            alt="Icon Adolescents"
          />
        );

      case 'Couples':
        return (
          <Image
            src="/static/icons/Couple.png"
            height={iconHeight}
            width={iconHeight}
            alt="Icon Couples"
          />
        );

      case 'Children':
        return (
          <Image
            src="/static/icons/Children.png"
            height={iconHeight}
            width={iconHeight}
            alt="Icon Children"
          />
        );

      case 'Adult':
      case 'Adults':
        return (
          <Image
            src="/static/icons/Man.png"
            height={iconHeight}
            width={iconHeight}
            alt="Icon Adults"
          />
        );

      case 'Companies':
        return (
          <Image
            src="/static/icons/Company.png"
            height={iconHeight}
            width={iconHeight}
            alt="Icon Company"
          />
        );
      case 'Families':
        return (
          <Image
            src="/static/icons/Families.png"
            height={iconHeight}
            width={iconHeight}
            alt="Icon Family"
          />
        );

      case 'Groups':
      case 'Group':
        return (
          <Image
            src="/static/icons/Group.png"
            height={iconHeight}
            width={iconHeight}
            alt="Group"
          />
        );
    }
  };

  return (
    <div className='relative flex flex-col p-[30px] gap-5'>
      <Text textStyle="h3">Client groups</Text>
      <div className='flex flex-wrap justify-between items-end'>
        {clientGroups.map((client) => (
          <div className='flex flex-col gap-2.5 items-center' key={client.value}>
            {renderIcon(client.label)}
            <p className='text-sm font-bold'>
              {client.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
